import { supabase } from '@/integrations/supabase/client'
import { logger } from './logger-service'

export const getChildSleepRecords = async (childId: string, limit?: number) => {
  logger.info('getChildSleepRecords called with params', { childId, limit });
  
  // Create base query
  let query = supabase
    .from('sleep_sessions')
    .select('*')
    .eq('child_id', childId)
    .order('end_time', { ascending: false }) 
    .limit(limit || 50);
  
  const { data, error } = await query;

  if (error) {
    logger.error('Error fetching sleep records', { childId, error });
    throw error;
  }

  logger.info('Sleep records fetched', { 
    childId, 
    recordCount: data.length,
    recordDates: data.slice(0, 3).map(r => r.start_time) 
  });

  // Calculate duration_minutes for each record
  const recordsWithDuration = data.map(record => {
    const startTime = new Date(record.start_time);
    const endTime = new Date(record.end_time);
    const durationMs = endTime.getTime() - startTime.getTime();
    const durationMinutes = Math.round(durationMs / (1000 * 60));

    return {
      ...record,
      duration_minutes: durationMinutes
    };
  });

  return recordsWithDuration;
}
